import React, { useState, useEffect, useRef, memo } from "react"

const DropdownFilter = memo(
  ({ width, label, iconSrc, options, onSelect, selectedCategory }) => {
    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef(null)
    const initialSelectionMade = useRef(false)

    useEffect(() => {
      if (
        options.length > 0 &&
        !selectedCategory &&
        onSelect &&
        !initialSelectionMade.current
      ) {
        initialSelectionMade.current = true
        onSelect(options[0].value)
      }
    }, [options, selectedCategory, onSelect])

    useEffect(() => {
      if (options.length > 0 && !selectedCategory) {
        initialSelectionMade.current = false
      }
    }, [options])

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false)
        }
      }

      document.addEventListener("mousedown", handleClickOutside)
      return () => {
        document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [])

    const handleSelect = (option) => {
      setIsOpen(false)
      if (onSelect) {
        onSelect(option.value)
      }
    }

    const selectedLabel =
      options.find((opt) => opt.value === selectedCategory)?.label || label

    const lang = localStorage.getItem("language") || "ar"

    return (
      <div
        ref={dropdownRef}
        className={`relative select-dropdown ${
          lang === "ar" ? "ml-10" : "mr-10"
        }`}
        style={{
          width: width,
          display: "flex",
          alignItems: "center",
          gap: "8px",
          position: "relative",
          cursor: "pointer",
          borderRadius: "10px",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {/* 👇 Left-side filter icon */}
        <img
          src="/dashboard/Vector.svg"
          alt="filter-icon"
          style={{ width: "16px", height: "16px", marginRight: "6px" }}
        />

        {/* Label text */}
        <p className="mb-0 text-14 font-400 text-A1A1A1 flex-grow-1">
          {selectedLabel}
        </p>

        {/* 👇 Right-side dropdown arrow */}
        <img
          src={iconSrc}
          alt="dropdown-icon"
          style={{
            width: "22px",
            height: "22px",
            transform: isOpen ? "rotate(180deg)" : "none",
            transition: "0.2s ease",
          }}
        />

        {/* 👇 Dropdown options */}
        {isOpen && (
          <div
            className="absolute comon-dropdown"
            style={{
              left: 0,
              top: "110%",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
              zIndex: 1000,
            }}
          >
            {options.map((option, index) => (
              <div
                key={`${option.value}-${index}`}
                className="dropdown-option"
                onClick={() => handleSelect(option)}
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#333",
                  borderBottom:
                    index !== options.length - 1 ? "1px solid #f0f0f0" : "none",
                }}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
)

export default DropdownFilter
